import React from 'react';
import { Box, Text, Heading, Link } from '@chakra-ui/react';
import CollapsibleItems from '../../components/shared/CollapsibleItems';

const SECURITY_TRUST_ITEMS = [
  {
    title: 'Information Security Policy',
    content:
      'Describes both acceptable and prohibited use of our networks, the Internet (including social media), laptops, and other devices. It also describes password and multi-factor authentication requirements.',
  },
  {
    title: 'Access Management',
    content:
      'We practice the security principle of least privilege. We allow access to information and resources to only those who need it to perform their role. We keep records of all access requests and audit our accounts regularly.',
  },
  {
    title: 'Information Asset Management',
    content:
      'Describes how we classify information at HOVER. These classifications govern the treatment of information assets, as we protect your data, as well as our intellectual property.',
  },
];

const SecuritySection = () => (
  <Box>
    <Heading mt="14" mb="7">
      Security and Privacy
    </Heading>
    <Text as="p">
      We train our employees on our security and privacy policies. Our policies
      govern acceptable and prohibited use of our networks and services. More
      importantly, they describe how we protect your personal data. You can
      review how we protect your privacy <Link href="/privacy">here</Link>.
    </Text>
    <Text as="br" />
    <Text as="p">Some of our most important policies include:</Text>
    <CollapsibleItems items={SECURITY_TRUST_ITEMS} />
  </Box>
);

export default SecuritySection;
